import { isAdHocCase } from '@/shared/ad-hoc-evidence';
import { isAllCasesSelection } from '@/shared/case-summary';
import type { FeatureFlagTypes } from '@/shared/types';

/**
 * LaunchDarkly flag key as configured in LD (and as returned by
 * ``identify()`` / ``variation()``). Only ``useFlags()`` camelCases it.
 */
export const MOBILE_ANALYSIS_AGENT_LD_KEY = 'mobile-analysis-agent';

/** React SDK ``useFlags()`` key for the same flag. */
export const MOBILE_ANALYSIS_AGENT_FLAG = 'mobileAnalysisAgent';

type FeatureFlags = Record<string, FeatureFlagTypes | undefined> | null | undefined;

/**
 * Fail closed so missing, malformed, or not-yet-loaded flag values preserve
 * the standard product experience.
 *
 * Reads the camelCased ``useFlags()`` key. Do not pass ``identify()`` maps
 * here — those keep {@link MOBILE_ANALYSIS_AGENT_LD_KEY}.
 */
export function isMobileAnalysisAgentEnabled(flags: FeatureFlags): boolean {
  return flags?.[MOBILE_ANALYSIS_AGENT_FLAG] === true;
}

/**
 * Mobile forensic analysis runs against one case's phone extractions.
 * All Cases and My Files (the personal files case) have no single case
 * acquisition set, so the control stays hidden there even when the flag is on.
 */
export function isMobileAnalysisAvailableForCase(
  flags: FeatureFlags,
  caseId: string | null | undefined,
  personalFilesCaseId?: string | null,
): boolean {
  return (
    isMobileAnalysisAgentEnabled(flags) &&
    !!caseId?.trim() &&
    !isAllCasesSelection(caseId) &&
    !isAdHocCase(caseId, personalFilesCaseId)
  );
}
